import { useEffect, useMemo } from "react";
import { t } from "../../translations";

import { useSelector } from "react-redux";
import { useSortBy, useTable } from "react-table";
import "../styles/section-chef.css";

import { Aa } from "../functions/Aa";

const TableBlog = ({ data, updateBlog, deleteBlog }) => {
  let lang = useSelector((state) => state.lang);

  useEffect(() => {}, []);

  const columns = useMemo(
    () => [
      {
        Header: t("common.title_2", lang),
        accessor: "title",
        Cell: ({ row }) => (
          <div>
            <p
              style={{
                fontSize: 16
              }}
            >
              {Aa(row?.original?.title)}
            </p>
          </div>
        )
      },
      {
        Header: t("common.content_2", lang),
        accessor: "message",
        Cell: ({ row }) => (
          <div>
            <p
              style={{
                fontSize: 15,
                color: "#000"
              }}
            >
              {Aa(row?.original?.message?.slice(0, 100) + "...")}
            </p>
          </div>
        )
      },
      {
        Header: "Actions",
        accessor: "actions",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            {row.original?.status === false && (
              <span
                className="action-btn-food"
                style={{
                  color: "blue",
                  textDecorationLine: "underline"
                }}
                onClick={() => {
                  updateBlog(row.original?._id, 1);
                }}
              >
                {t("common.make_live", lang)}
              </span>
            )}

            {row.original?.status === true && (
              <span
                className="action-btn-food"
                style={{
                  color: "blue",
                  textDecorationLine: "underline"
                }}
                onClick={() => {
                  updateBlog(row.original?._id, 1);
                }}
              >
                {t("common.hide_it_2", lang)}
              </span>
            )}

            <span
              className="action-btn-food"
              style={{
                color: "#ff114d",
                textDecorationLine: "underline"
              }}
              onClick={() => {
                deleteBlog(row.original?._id);
              }}
            >
              {t("buttons.delete_2", lang)}
            </span>
          </div>
        )
      },
      {
        Header: t("common.pic", lang),
        accessor: "pic",
        Cell: ({ row }) => (
          <a href={row?.original?.pic} target="_blank" rel="noreferrer">
            <img
              src={row?.original?.pic}
              style={{
                width: 80,
                height: 50,
                marginTop: 5,
                objectFit: "contain"
              }}
              alt="food-pic"
            />
          </a>
        )
      },

      {
        Header: t("common.status_6", lang),
        accessor: "status",
        Cell: ({ row }) => (
          <div
            style={{
              padding: 5,
              minWidth: 100,
              maxWidth: 150,
              height: 40,
              backgroundColor:
                row?.original?.status === false ? "#ff114d" : "blue",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 20
            }}
          >
            {row?.original?.status === false && t("common.inactif", lang)}

            {row?.original?.status === true && t("common.actif", lang)}
          </div>
        )
      },
      {
        Header: t("common.date_time_2", lang),
        accessor: "createdAt",
        Cell: ({ row }) => (
          <div>
            <p
              style={{
                fontSize: 18
              }}
            >
              {row?.original?.createdAt?.slice(0, 10) +
                " " +
                row?.original?.createdAt?.slice(11, 16)}
            </p>
          </div>
        )
      }
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data
      },
      useSortBy
    );

  return (
    <div className="table-container">
      <table {...getTableProps()} className="table-menu">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="table-header-menu"
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="table-header-cell-menu"
                >
                  {column.render("Header")}
                  {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="table-body-menu">
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="table-row-menu">
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="table-cell-menu">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableBlog;
